import React, { Component } from 'react';
import { connect } from 'react-redux';
import { t } from 'ttag';
import CaravanConfigurationApi from '../../services/apis/caravanConfiguration';
import style from './saveConfiguration.scss';
import ConfigurationActions from '../../redux/configurationRedux';
import ShowFormActions from '../../redux/showFormRedux';

class SaveConfiguration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            temp: '',
            configuration: props.configuration,
        };
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    onToggleDialog = () => {
        this.props.toggleForm();
    };

    handleInputChange = (event) => {
        this.props.updateFormData(event.target.name, event.target.value);
    };

    onSaveConfiguration = () => {
        if (this.props.configuration.formData.salutation !== 'salutation-2') {
            this.props.updateFormData('salutation', 'salutation-1');
        }
        this.setState();
        const configurationCodePromise = CaravanConfigurationApi.save(
            this.props.configuration
        );
        configurationCodePromise.then(data => {
            if (data.data.success) {
                alert(t`Ihr Konfigurationscode lautet ${data.data.data[0]}`);
            } else {
                alert(t`Es ist ein Fehler beim Speichern der Konfiguration aufgetreten.`);
            }
        });
    };

    renderForm = () => (
        <div className={style.container}>
            <div className={style.formBackground} onClick={() => this.onToggleDialog()} />
            <div className={style.formContainer}>
                <div className={style.saveDialog}>
                    <h3 align="left">{t`Konfiguration speichern`}</h3>
                    <hr />
                    <div className={style.row}>
                        <div className={style.column}>
                            <label htmlFor="salutation" className={style.inputLabel}>{t`Anrede`}</label>
                            <select id="salutation" name="salutation" onChange={this.handleInputChange} value={this.props.configuration.formData.salutation}>
                                <option value="salutation-1">{t`Herr`}</option>
                                <option value="salutation-2">{t`Frau`}</option>
                            </select>

                            <label htmlFor="first_name" className={style.inputLabel}>{t`Vorname`}</label>
                            <input id="first_name" name="first_name" type="text" value={this.props.configuration.formData.first_name} onChange={this.handleInputChange} className={style.input} />

                            <label htmlFor="last_name" className={style.inputLabel}>{t`Nachname`}</label>
                            <input id="last_name" name="last_name" type="text" value={this.props.configuration.formData.last_name} onChange={this.handleInputChange} className={style.input} />

                            <label htmlFor="email" className={style.inputLabel}>{t`E-Mail`}</label>
                            <input id="email" name="email" type="text" value={this.props.configuration.formData.email} onChange={this.handleInputChange} className={style.input} />

                            <label htmlFor="phone" className={style.inputLabel}>{t`Telefon`}</label>
                            <input id="phone" name="phone" type="text" value={this.props.configuration.formData.phone} onChange={this.handleInputChange} className={style.input} />

                            <label htmlFor="fax" className={style.inputLabel}>{t`Fax`}</label>
                            <input id="fax" name="fax" type="text" value={this.props.configuration.formData.fax} onChange={this.handleInputChange} className={style.input} />
                        </div>
                        <div className={style.column}>
                            <label htmlFor="street" className={style.inputLabel}>{t`Straße`}</label>
                            <input id="street" name="street" type="text" value={this.props.configuration.formData.street} onChange={this.handleInputChange} className={style.input} />

                            <label htmlFor="zip" className={style.inputLabel}>{t`Postleitzahl`}</label>
                            <input id="zip" name="zip" type="text" value={this.props.configuration.formData.zip} onChange={this.handleInputChange} className={style.input} />

                            <label htmlFor="city" className={style.inputLabel}>{t`Stadt`}</label>
                            <input id="city" name="city" type="text" value={this.props.configuration.formData.city} onChange={this.handleInputChange} className={style.input} />

                            <label htmlFor="country" className={style.inputLabel}>{t`Land`}</label>
                            <input id="country" name="country" type="text" value={this.props.configuration.formData.country} onChange={this.handleInputChange} className={style.input} />

                            <label htmlFor="company" className={style.inputLabel}>{t`Firma`}</label>
                            <input id="company" name="company" type="text" value={this.props.configuration.formData.company} onChange={this.handleInputChange} className={style.input} />

                            <label htmlFor="industry" className={style.inputLabel}>{t`Beruf/Gewerbe`}</label>
                            <input id="industry" name="industry" type="text" value={this.props.configuration.formData.industry} onChange={this.handleInputChange} className={style.input} />

                        </div>
                        <div className={style.column}>
                            <label htmlFor="date_of_birth" className={style.inputLabel}>{t`Geburtstdatum`}</label>
                            <input id="date_of_birth" name="date_of_birth" type="text" value={this.props.configuration.formData.date_of_birth} onChange={this.handleInputChange} className={style.input} />

                            <label htmlFor="place_of_birth" className={style.inputLabel}>{t`Geburtsort`}</label>
                            <input id="place_of_birth" name="place_of_birth" type="text" value={this.props.configuration.formData.place_of_birth} onChange={this.handleInputChange} className={style.input} />

                            <label htmlFor="id_number_place" className={style.inputLabel}>{t`Ausweis-Nr./Ort`}</label>
                            <input id="id_number_place" name="id_number_place" type="text" value={this.props.configuration.formData.id_number_place} onChange={this.handleInputChange} className={style.input} />

                            <button
                                className={style.saveButton}
                                onClick={() => this.onToggleDialog()}
                            >
                                <span>{t`Schließen`}</span>
                            </button>
                            <button
                                className={style.saveButton}
                                onClick={() => this.onSaveConfiguration()}
                            >
                                <span>{t`Konfiguration speichern`}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    render = () => (
        <div>
            <button onClick={() => this.onToggleDialog()}>
                <div className={style.iconSave} />
                {t`Konfiguration speichern`}
            </button>
            { this.props.showForm.visibility ? this.renderForm() : null }
        </div>
    );
}

const mapStateToProps = state => ({
    configuration: state.configuration,
    showForm: state.showForm,
});

const mapDispatchToProps = dispatch => ({
    updateFormData: (fieldName, value) =>
        dispatch(ConfigurationActions.updateFormData(fieldName, value)),
    toggleForm: () =>
        dispatch(ShowFormActions.formToggle()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SaveConfiguration);
